import React from 'react'
import Map from './GoogleMap';
import { Dialog, Button } from "@blueprintjs/core";
import { Translate, I18n } from "react-redux-i18n";

class GoogleLocation extends React.Component {
    state={
        selected_location:{
            address: "",
            city: "",
            country: "",
            state: "",
            lat: "",
            lng: "",
            area:""
        }
    }   

    updateLocation=(location)=>{
        this.setState({selected_location:location});
    }
    saveLocation=()=>{
        let location_details = {...this.state.selected_location};
        if(location_details.city===""){
            location_details.city = location_details.area?location_details.area:"";    
        }
        this.props.onSave(location_details);
    }
    render() {
        return(
            <Dialog
                onClose={this.props.onClose}
                title={I18n.t("google_maps_modal.title")}
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                enforceFocus={true}
                isOpen={this.props.showModal}
                usePortal={true}
                className="google-location-modal"
                portalClassName="google-location-modal-container"
            >    
                <div className="dialog-wrapper gmaps">
                    <div className="gmap-container">
                        <Map
                            google={this.props.google}
                            center={this.props.location}
                            height='320px'
                            marginBottom='0'
                            zoom={15}
                            updateLocation={this.updateLocation}
                        />
                    </div>
                    <Button                    
                        className="login-button"
                        intent="primary"
                        fill={true}
                        type="button"
                        onClick={this.saveLocation}
                    >
                        <Translate value="google_maps_modal.save_location" />
                    </Button>
                </div>
            </Dialog>          
        )
    }
}
export default GoogleLocation;
